import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getChatSessionList, getSessionMemberList, deleteChatSession } from '../../api/chat';
import { message } from 'antd';

// 获取聊天会话列表
export const fetchChatSessions = createAsyncThunk(
  'chatSession/fetchChatSessions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getChatSessionList(params);
      if (response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response.message || '获取聊天会话列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取聊天会话列表失败');
    }
  }
);

// 获取会话成员列表
export const fetchSessionMembers = createAsyncThunk(
  'chatSession/fetchSessionMembers',
  async ({ sessionId, params }, { rejectWithValue }) => {
    try {
      const response = await getSessionMemberList(sessionId, params);
      if (response.code === 200) {
        return { sessionId, data: response.data };
      }
      return rejectWithValue(response.message || '获取会话成员列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取会话成员列表失败');
    }
  }
);

// 删除聊天会话
export const removeChatSession = createAsyncThunk(
  'chatSession/removeChatSession',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteChatSession(id);
      if (response.code === 200) {
        message.success('删除聊天会话成功');
        // 刷新列表
        dispatch(fetchChatSessions({ pageNum: 1, pageSize: 10 }));
        return id;
      }
      return rejectWithValue(response.message || '删除聊天会话失败');
    } catch (error) {
      return rejectWithValue(error.message || '删除聊天会话失败');
    }
  }
);

const initialState = {
  sessions: [],
  total: 0,
  current: 1,
  pageSize: 10,
  loading: false,
  error: null,
  currentSession: null,
  members: [],
  membersTotal: 0,
  membersCurrent: 1,
  membersPageSize: 10,
  membersLoading: false,
  membersError: null,
};

const chatSessionSlice = createSlice({
  name: 'chatSession',
  initialState,
  reducers: {
    setCurrentSession: (state, action) => {
      state.currentSession = action.payload;
    },
    clearCurrentSession: (state) => {
      state.currentSession = null;
    },
    resetMembers: (state) => {
      state.members = [];
      state.membersTotal = 0;
      state.membersCurrent = 1;
      state.membersPageSize = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      // 获取聊天会话列表
      .addCase(fetchChatSessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.sessions = action.payload.records;
        state.total = action.payload.total;
        state.current = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchChatSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        message.error(action.payload || '获取聊天会话列表失败');
      })
      
      // 获取会话成员列表
      .addCase(fetchSessionMembers.pending, (state) => {
        state.membersLoading = true;
        state.membersError = null;
      })
      .addCase(fetchSessionMembers.fulfilled, (state, action) => {
        state.membersLoading = false;
        state.members = action.payload.data.records;
        state.membersTotal = action.payload.data.total;
        state.membersCurrent = action.payload.data.current;
        state.membersPageSize = action.payload.data.size;
      })
      .addCase(fetchSessionMembers.rejected, (state, action) => {
        state.membersLoading = false;
        state.membersError = action.payload;
        message.error(action.payload || '获取会话成员列表失败');
      })
      
      // 删除聊天会话
      .addCase(removeChatSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeChatSession.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removeChatSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        message.error(action.payload || '删除聊天会话失败');
      });
  },
});

export const { setCurrentSession, clearCurrentSession, resetMembers } = chatSessionSlice.actions;

export default chatSessionSlice.reducer; 